import React, { useState, useEffect, useContext } from 'react'
import { Table } from 'react-bootstrap-v5';
import { Form, Modal } from 'react-bootstrap';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Swal from 'sweetalert2'
import GetPagePermission from '../components/GetPagePermission';
import { AppContext } from '../context/AppContext';

interface Product {
    productName: string;
    idItems: number;
    unitName: string;
    packing: number;
    size: number;
    productionCost: number;
    previousCost: number;
    salePerUnit: number;
    costPerUnit: number;
    profitMargin: number;
    discountPercentAdmin: number;
    discountPercentSr: number;
    [key: string]: any; // Index signature
}

interface Category {
    id_item_categoriess: number;
    category_name: string;
    products: Product[];
}

interface Item {
    idItems: number;
    itemName: string;
    itemCode: string;
    categoryName: string;
    unitName: string;
}

interface ProductCostSummary {
    idProducts: number;
    productName: string;
    alternateName: string;
    itemCode: string;
    size: number;
    packing: string;
    unitName: string;
    itemUnitName: string;
    itemCost: number;
    overheadCost: number;
    vat: number;
    weightedLoss: number;
    totalCost: number;
}

interface ProductCostItemRow {
    idProductCostItems: number | null;
    idItems: number | null;
    itemName: string;
    categoryName: string;
    quantity: number;
    rate: number;
    amount: number;
    unitName?: string;
}

export default function Products() {

    const { currentUser } = useContext(AppContext);
    const showBomExport = Number(currentUser?.id) === 3;

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return myToken != null ? JSON.parse(myToken) : '';
    };

    const hasProductStatusPermission = GetPagePermission("/product-status-change");
    const hasProductFormulationPermission = GetPagePermission("/product-formulation-view");
    const [categories, setCategories] = useState<Category[]>([]);
    const [originalCategories, setOriginalCategories] = useState<Category[]>([]);
    const [items, setItems] = useState<Item[]>([]);
    const [searchTerm, setSearchTerm] = useState('');

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [showInactiveProducts, setShowInactiveProducts] = useState(false);
    const [showFormulationModal, setShowFormulationModal] = useState(false);
    const [selectedAlternateForFormulation, setSelectedAlternateForFormulation] = useState<any | null>(null);
    const [selectedBomForFormulation, setSelectedBomForFormulation] = useState<any | null>(null);
    const [formulationSummary, setFormulationSummary] = useState<ProductCostSummary | null>(null);
    const [formulationItems, setFormulationItems] = useState<ProductCostItemRow[]>([]);
    const [formulationLoading, setFormulationLoading] = useState(false);

    useEffect(() => {
        getAllProjects();
        getProducts(null);
        getItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getAllProjects = async () => {

        const url = process.env.REACT_APP_API_URL + 'projects';
        const response = await fetch(url, getRequestOptions());
        const data = await response.json();

        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setProjects(data.data)

        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setProjects(allProjects);
        }

    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        getProducts(project);
    }

    const handleShowInactiveProductsChange = (checked: boolean) => {
        setShowInactiveProducts(checked);
        // No API call - filter locally from already-fetched data
    }

    const getProducts = (project: any) => {
        // Always fetch all data (active + inactive); frontend filters by visibility
        fetch(
            process.env.REACT_APP_API_URL + 'allProductCategoriesWithSeparateAlternateNames?idProjects=' + ((project === null || project?.value === '') ? '' : project.value) + '&status=showAll',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let categories = resp.map((item: any) => {
                    item.label = item.category_name;
                    item.value = item.id_item_categoriess;
                    return item
                });
                setCategories(categories);
                setOriginalCategories(categories);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getItems = () => {
        //get Categories
        fetch(
            process.env.REACT_APP_API_URL + 'production-items?idProjects=' + ((project === null) ? '' : project.value),
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let items = resp.data.map((item: any) => {
                    return item
                });
                setItems(items);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    // const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setSearchTerm(event.target.value);
    // }

    // const filterProducts = (category: any) => {
    //     const filteredProducts = category.products?.filter((product: any) => {
    //         const name = product.productName.toLowerCase();
    //         const searchTermLower = searchTerm.toLowerCase();
    //         return name.includes(searchTermLower);
    //     }) || [];
    //     return filteredProducts;
    // }

    const handleSearchProductChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const searchValue = event.target.value.toLowerCase();
            setSearchTerm(searchValue);
    
            if (searchValue === "") {
                setCategories(originalCategories);
            } else {
                const filteredCategories = originalCategories.map((category) => {
                    return {
                        ...category,
                        products: category.products.filter((product) => {
                            const matchesProductName = product.productName.toLowerCase().includes(searchValue);
                            const matchesAlternateName = product.alternateNames && product.alternateNames.some((altName: any) => 
                                altName.name && altName.name.toLowerCase().includes(searchValue)
                            );
                            return matchesProductName || matchesAlternateName;
                        }),
                    };
                });
                setCategories(filteredCategories);
            }
        };

    const hasProductBom = (product: Product) => Array.isArray(product.boms) && product.boms.length > 0;

    const getBomId = (bom: any) => bom.id_product_boms ?? bom.idProductBoms;

    const getBomName = (bom: any) => bom.bom_name ?? bom.bomName ?? 'BOM';

    const renderFormulationCell = (product: Product, alternate?: any) => (
        <td className='text-center align-middle'>
            {hasProductBom(product) ? (
                <div>
                    {product.boms.map((bom: any, bomIndex: number) => (
                        <React.Fragment key={getBomId(bom)}>
                            {product.boms.length > 1 && bomIndex > 0 && (
                                <hr className="my-1" />
                            )}
                            <button
                                type="button"
                                className="btn btn-link btn-sm p-0"
                                onClick={() => openFormulationModal(product, alternate, bom)}
                            >
                                {getBomName(bom)}
                            </button>
                        </React.Fragment>
                    ))}
                </div>
            ) : (
                <span className="text-muted">-</span>
            )}
        </td>
    );

    const openFormulationModal = (product: Product, alternate?: any, bom?: any) => {
        setSelectedAlternateForFormulation(alternate || null);
        setSelectedBomForFormulation(bom || null);
        setShowFormulationModal(true);

        const productId = product.idProducts;
        const bomId = bom ? getBomId(bom) : null;
        if (!productId || !bomId) {
            setFormulationSummary(null);
            setFormulationItems([]);
            return;
        }

        setFormulationLoading(true);
        fetch(
            process.env.REACT_APP_API_URL + 'products/' + productId + '?id_product_bom=' + bomId,
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                const data = resp.data || {};
                const summary: ProductCostSummary = {
                    idProducts: data.idProducts,
                    productName: data.productName,
                    alternateName: data.alternateName,
                    itemCode: data.itemCode,
                    size: parseFloat(data.size),
                    packing: data.packing,
                    unitName: data.unitName,
                    itemUnitName: data.itemUnitName,
                    itemCost: parseFloat(data.itemCost),
                    overheadCost: parseFloat(data.overheadCost),
                    vat: parseFloat(data.vat),
                    weightedLoss: parseFloat(data.weightedLoss),
                    totalCost: parseFloat(data.totalCost),
                };
                setFormulationSummary(summary);

                const items: ProductCostItemRow[] = (resp.items || []).map((item: any) => ({
                    ...item,
                    rate: parseFloat(item.rate),
                    quantity: parseFloat(item.quantity),
                    amount: parseFloat(item.amount),
                }));
                setFormulationItems(items);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
                setFormulationSummary(null);
                setFormulationItems([]);
            })
            .finally(() => {
                setFormulationLoading(false);
            });
    };

    const closeFormulationModal = () => {
        setShowFormulationModal(false);
        setSelectedAlternateForFormulation(null);
        setSelectedBomForFormulation(null);
        setFormulationSummary(null);
        setFormulationItems([]);
        setFormulationLoading(false);
    };

    // Visibility: show row if active OR showInactiveProducts is on
    const isProductRowVisible = (product: any) => product.status === 'Active' || showInactiveProducts;
    const isAlternateVisible = (alt: any) => alt.status === 'Active' || showInactiveProducts;

    const getVisibleAlternates = (product: any) => (product.alternateNames || []).filter(isAlternateVisible);

    const getCategoryVisibleCount = (category: any) => {
        let count = 0;
        category.products?.forEach((product: any) => {
            const productVisible = isProductRowVisible(product);
            const visibleAlternates = getVisibleAlternates(product);
            if (productVisible) count += 1 + visibleAlternates.length;
            else if (visibleAlternates.length > 0) count += visibleAlternates.length;
        });
        return count;
    };

    const confirmStatusProduct = async (idProducts: number, status: string) => {
        var msgTxt1 = status === 'Inactive' ? 'INACTIVE' : 'ACTIVE'
        var msgTxt2 = status === 'Inactive' ? 'Deactivate' : 'Activate'
        const confirm = await Swal.fire({
            title: 'Are you sure to proceed?',
            text: "This will mark this product as " + msgTxt1,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, ' + msgTxt2 + ' it!',
        })
        if (confirm.value) {
            const requestOptions = postRequestOptions()
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}confirmStatusProduct/${idProducts}/${status}`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    getProducts(project)
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: 'Could not update product status.',
                    })
                }
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: 'Could not update product status.',
                })
            }
        }
    }

    const confirmStatusAlternateName = async (idAlternateNames: number, status: string) => {
        var msgTxt1 = status === 'Inactive' ? 'INACTIVE' : 'ACTIVE'
        var msgTxt2 = status === 'Inactive' ? 'Deactivate' : 'Activate'
        const confirm = await Swal.fire({
            title: 'Are you sure to proceed?',
            text: "This will mark this alternate name as " + msgTxt1,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, ' + msgTxt2 + ' it!',
        })
        if (confirm.value) {
            const requestOptions = postRequestOptions()
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}productGroupAlternateNameStatus/${idAlternateNames}/${status}`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    getProducts(project)
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: 'Could not update alternate name status.',
                    })
                }
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: 'Could not update alternate name status.',
                })
            }
        }
    }

    useEffect(() => {
        if (projects.length === 1) {
            setProject({ label: projects[0]['label'], value: projects[0]['value'] })
        }
    }, [projects])

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header card-header-stretch overflow-auto d-flex flex-wrap align-items-center justify-content-between gap-3'>
                    <div className='card-title mb-0'>
                        <h3 className='card-label'>All Product List</h3>
                    </div>
                    <div className='card-toolbar d-flex flex-wrap gap-2 align-items-center'>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='btn btn-sm btn-primary'
                            href={`${process.env.REACT_APP_BACKEND}productExport?export=true&idProjects=${project?.value ?? ''}&showOnlyWithStock=false&showOnlyWithCostSetup=false&sortBySize=false&searchProduct=${encodeURIComponent(searchTerm)}&token=${jwt()}`}
                        >
                            <i className='fas fa-download me-1' /> Export
                        </a>
                        {showBomExport ? (
                            <a
                                target='_blank'
                                rel='noreferrer'
                                className='btn btn-sm btn-primary'
                                href={`${process.env.REACT_APP_BACKEND}bomExport?export=true&idProjects=${project?.value ?? ''}&status=showAll&token=${jwt()}`}
                            >
                                <i className='fas fa-download me-1' /> BOM Export
                            </a>
                        ) : null}
                        {showBomExport ? (
                            <a
                                target='_blank'
                                rel='noreferrer'
                                className='btn btn-sm btn-primary'
                                href={`${process.env.REACT_APP_BACKEND}bomExport?export=true&idProjects=${project?.value ?? ''}&status=showAll&type=Active&token=${jwt()}`}
                            >
                                <i className='fas fa-download me-1' /> Active BOM Export
                            </a>
                        ) : null}
                    </div>
                </div>
                <div className="card-body">

                    <Tabs
                        defaultActiveKey="product"
                        id="uncontrolled-tab-example"
                        className="mb-3 ml-3 mr-3"
                    >
                        <Tab eventKey="product" title="Product">

                            <div className="form-group row">
                                <label htmlFor="project" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Project</label>
                                <div className="col-lg-5">
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        placeholder={project.label}
                                    />
                                </div>
                                <div className="col-md-3" style={{ marginTop: "-10px" }}>
                                    <Form.Group controlId="showInactiveProducts">
                                        <Form.Label></Form.Label>
                                        <Form.Check
                                            type="switch"
                                            id="show-inactive-products-switch"
                                            label="Show Inactive Products/Alternate Names"
                                            className="form-switch"
                                            checked={showInactiveProducts}
                                            onChange={(e) => handleShowInactiveProductsChange(e.target.checked)}
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            <div className='row mt-6'>
                                <div className='col-md-6 mb-3'>
                                    <input
                                        type='text'
                                        className='form-control form-control-sm'
                                        placeholder='Search...'
                                        value={searchTerm}
                                        onChange={handleSearchProductChange}
                                    />
                                </div>
                            </div>


                            <Table size='sm' bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: (hasProductStatusPermission || hasProductFormulationPermission) ? '26%' : '36%' }}>Category/Product Name</th>
                                       
                                        {hasProductStatusPermission ? (
                                            <th className='text-center' style={{ width: '8%' }}>Status</th>
                                        ) : null}
                                        {hasProductFormulationPermission ? (
                                            <th className='text-center' style={{ width: '10%' }}>Formulation</th>
                                        ) : null}
                                        <th className='text-center' style={{ width: '8%' }}>Packing</th>
                                        <th className='text-center' style={{ width: '8%' }}>Size</th>
                                        <th className='text-end' style={{ width: '8%' }}>Sale/Unit</th>
                                        <th className='text-end' style={{ width: '8%' }}>Unit</th>
                                    </tr>
                                </thead>

                                {categories?.map((category, catIndex) => {
                                    const visibleCount = getCategoryVisibleCount(category);
                                    const categoryColSpan = 5
                                        + (hasProductStatusPermission ? 1 : 0)
                                        + (hasProductFormulationPermission ? 1 : 0);
                                    return (
                                    <tbody key={catIndex}>

                                        {visibleCount > 0 && searchTerm === '' &&
                                            <tr>
                                                <td colSpan={categoryColSpan}><b>{category.category_name + '(' + visibleCount + ')'}</b></td>
                                            </tr>
                                        }

                                        {visibleCount > 0 && searchTerm !== '' &&
                                            <tr>
                                                <td colSpan={categoryColSpan}><b>{category.category_name + '(' + visibleCount + ')'}</b></td>
                                            </tr>
                                        }

                                        {category.products.map((product, productIndex) => {
                                            const visibleAlternates = getVisibleAlternates(product);
                                            const productRowVisible = isProductRowVisible(product);
                                            const hasVisibleRows = productRowVisible || visibleAlternates.length > 0;
                                            if (!hasVisibleRows) return null;

                                            const rowspan = (productRowVisible ? 1 : 0) + visibleAlternates.length;
                                            const isProductInactive = product.status === 'Inactive';
                                            const sharedCells = (
                                                <>
                                                    <td className='text-center align-middle' rowSpan={rowspan}>{product.packing + ' ' + product.groupUnitName}</td>
                                                    <td className='text-center align-middle' rowSpan={rowspan}>{product.size + ' ' + product.groupUnitName}</td>
                                                    <td className='text-end align-middle' rowSpan={rowspan}>{Number(product.salePerUnit).toLocaleString('en-US', {
                                                        style: 'decimal',
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}</td>
                                                    <td className='text-end align-middle' rowSpan={rowspan}>{product.unitName}</td>
                                                </>
                                            );
                                            
                                            return (
                                                <React.Fragment key={`${catIndex}.${productIndex}`}>
                                                    {productRowVisible && (
                                                        <tr>
                                                            <td className='ps-5'><span style={isProductInactive ? { backgroundColor: '#FAA0A0' } : {}}>{product.productName}</span></td>
                                                            {hasProductStatusPermission ? (
                                                                <td className='text-center align-middle'>
                                                                    {product.idProducts !== undefined && product.status === 'Active' &&
                                                                        <span onClick={() => confirmStatusProduct(product.idProducts, 'Inactive')} className="btn btn-success btn-sm" style={{ cursor: 'pointer' }}>Active</span>
                                                                    }
                                                                    {product.idProducts !== undefined && product.status === 'Inactive' &&
                                                                        <span onClick={() => confirmStatusProduct(product.idProducts, 'Active')} className="btn btn-danger btn-sm" style={{ cursor: 'pointer' }}>Inactive</span>
                                                                    }
                                                                    {product.idProducts !== undefined && (!product.status || (product.status !== 'Active' && product.status !== 'Inactive')) &&
                                                                        <span onClick={() => confirmStatusProduct(product.idProducts, 'Active')} className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>Set Status</span>
                                                                    }
                                                                </td>
                                                            ) : null}
                                                            {hasProductFormulationPermission ? (
                                                                renderFormulationCell(product)
                                                            ) : null}
                                                            {sharedCells}
                                                        </tr>
                                                    )}
                                                    {visibleAlternates.map((altName: any, altIndex: number) => {
                                                        const isAltNameInactive = altName.status === 'Inactive';
                                                        const isFirstAlt = !productRowVisible && altIndex === 0;
                                                        return (
                                                            <tr key={`${catIndex}.${productIndex}.${altIndex}`}>
                                                                <td className='ps-5'>
                                                                    <span style={{padding: '0 3px', fontSize: isFirstAlt ? 'inherit' : '10px', ...(isAltNameInactive ? { backgroundColor: '#FAA0A0' } : {}) }}>{altName.name}</span>
                                                                </td>
                                                                {hasProductStatusPermission ? (
                                                                    <td className='text-center'>
                                                                        {altName.id_product_group_alternate_names && altName.status === 'Active' &&
                                                                            <span onClick={() => confirmStatusAlternateName(altName.id_product_group_alternate_names, 'Inactive')} className="btn btn-success btn-sm" style={{ cursor: 'pointer' }}>Active</span>
                                                                        }
                                                                        {altName.id_product_group_alternate_names && altName.status === 'Inactive' &&
                                                                            <span onClick={() => confirmStatusAlternateName(altName.id_product_group_alternate_names, 'Active')} className="btn btn-danger btn-sm" style={{ cursor: 'pointer' }}>Inactive</span>
                                                                        }
                                                                        {altName.id_product_group_alternate_names && (!altName.status || (altName.status !== 'Active' && altName.status !== 'Inactive')) &&
                                                                            <span onClick={() => confirmStatusAlternateName(altName.id_product_group_alternate_names, 'Active')} className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>Set Status</span>
                                                                        }
                                                                    </td>
                                                                ) : null}
                                                                {hasProductFormulationPermission ? (
                                                                    renderFormulationCell(product, altName)
                                                                ) : null}
                                                                {isFirstAlt && sharedCells}
                                                            </tr>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })}

                                    </tbody>
                                    );
                                })}
                            </Table>

                            {/* <pre>{JSON.stringify(categories, null, 2)}</pre> */}


                        </Tab>
                        <Tab eventKey="item" title="Item">
                            {/* <pre>{JSON.stringify(items, null, 2)}</pre> */}

                            <Table size='sm' striped bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: '25%' }}>Item Name</th>
                                        <th className='text-center' style={{ width: '25%' }}>Item Code</th>
                                        <th className='text-center' style={{ width: '25%' }}>Item Category</th>
                                        <th className='text-center' style={{ width: '25%' }}>Unit</th>
                                    </tr>
                                </thead>

                                {items?.map((item, itemIndex) => (
                                    <tbody key={itemIndex}>
                                        <tr>
                                            <td>{item.itemName}</td>
                                            <td className='text-center'>{item.itemCode}</td>
                                            <td className='text-center'>{item.categoryName}</td>
                                            <td className='text-center'>{item.unitName}</td>
                                        </tr>
                                    </tbody>
                                ))}
                            </Table>
                        </Tab>


                    </Tabs>
                </div>

                {hasProductFormulationPermission && (
                    <Modal show={showFormulationModal} onHide={closeFormulationModal} size="lg" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Product Formulation
                                {selectedBomForFormulation && ` - ${getBomName(selectedBomForFormulation)}`}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {formulationLoading && (
                                <p>Loading formulation...</p>
                            )}
                            {!formulationLoading && formulationSummary && (
                                <>
                                    <Table size='sm' bordered hover>
                                        <tbody>
                                            <tr>
                                                <td width={'30%'}>Product Name</td>
                                                <td width={'70%'}> : {formulationSummary.productName}</td>
                                            </tr>
                                            <tr>
                                                <td>Alternate Name</td>
                                                <td>
                                                    : {formulationSummary.alternateName}
                                                    {selectedAlternateForFormulation && selectedAlternateForFormulation.name &&
                                                        ` (Clicked: ${selectedAlternateForFormulation.name})`}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Product Code</td>
                                                <td> : {formulationSummary.itemCode}</td>
                                            </tr>
                                            <tr>
                                                <td>Size</td>
                                                <td> : {formulationSummary.size + ' ' + formulationSummary.itemUnitName}</td>
                                            </tr>
                                            <tr>
                                                <td>Pack</td>
                                                <td> : {formulationSummary.packing + ' ' + formulationSummary.itemUnitName}</td>
                                            </tr>
                                            <tr>
                                                <td>Unit</td>
                                                <td> : {formulationSummary.unitName}</td>
                                            </tr>
                                        </tbody>
                                    </Table>

                                    <Table size='sm' bordered hover>
                                        <thead>
                                            <tr>
                                                <th className="col-3">Item</th>
                                                <th className="col-2">Category</th>
                                                <th className="col-2">Quantity</th>
                                                <th className="col-1">Unit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formulationItems
                                                .filter((productItem) => Number(productItem.quantity) !== 0)
                                                .map((productItem, index) => (
                                                <tr key={'item' + index}>
                                                    <td className='text-left'>{productItem.itemName}</td>
                                                    <td>{productItem.categoryName}</td>
                                                    <td className='text-end'>{productItem.quantity}</td>
                                                    <td>{productItem.unitName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </>
                            )}
                            {!formulationLoading && !formulationSummary && (
                                <p>No formulation data found for this product.</p>
                            )}
                        </Modal.Body>
                    </Modal>
                )}

            </div>

        </>
    )
}
